import { http } from "Utils/http";
import { store } from 'Store';
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import DatatableBase from "Components/Datatable/DatatableBase";
import { isInObject } from "Utils/utilityFunctions";
import {ERROR_MESSAGES, STATUSES} from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import {httpDownload} from "../../../Utils/httpDownload";

const ListPSODirectoryBatchUpdate = () => {
  
  const dispatch = useDispatch();
  const loginState = store.getState().loginInfo;
  const [reloadListPSODirBatchUpdate, setReloadListPSODirBatchUpdate] = useState(false);
  const [listPSODirBatchUpdateSortColumn, setListPSODirBatchUpdateSortColumn] = useState({
    sortField: "batchId",
    sortDirection: "desc"
  });
  const batchState = ({ rowName }) => ({
    batchId: rowName.batchId,
    backRedirect: {
      path: location.pathname,
      state: { filter }
    }
  });
  const [filter, setFilter] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const BD_GENERATE_URL = "/api/psoDir/detailReport";
  
  const handleDateFormat = (time) => {
    if (time == null) return "";
    const d = new Date(time);
    const pad2 = (n) => String(n).padStart(2, "0");
    return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()} ` +
      `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  }
  
  const getData = async (filter) => {
    
    setFilter(filter);
    
    const call = {
      ...filter
    };
    const url = '/api/psoDir/listBatch';
    
    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }
  
  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];
    
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "batchId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo, isLink: true, linkData: { pathname: "/manage/viewBatch", text: "", state: batchState } }));
    listColumns.push(Datatable_Column({ name: "Batch Date", columnName: "batchDate", selectedRows: selectedList, formatFunction: handleDateFormat, sortable: false, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Last Modified", columnName: "releaseDate", selectedRows: selectedList, formatFunction: handleDateFormat, sortable: false, sortFieldNum: 2, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Number of Entry", columnName: "numOfEntry", selectedRows: selectedList, sortable: false, sortFieldNum: 3, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Number of New PSO", columnName: "numOfNewPSO", selectedRows: selectedList, sortable: false, sortFieldNum: 4, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Number of Delisted PSO", columnName: "numberOfDelistedPSO", selectedRows: selectedList, sortable: false, sortFieldNum: 5, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Status", columnName: "status", selectedRows: selectedList, sortable: true, sortFieldNum: 6, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Detail Report", columnName: "downloadReport", selectedRows: selectedList, sortable: false, sortFieldNum: 7, isButton: true, buttonData: {action: handleFileDownload, icon: null, text: "View Report"}}));
    
    return listColumns;
  }
  
  useEffect(() => {
    const passedData = location.state;
    
    if (isInObject("filter", passedData)) {
      setFilter(passedData.filter);
    }
    else {
      setFilter({
        startIndex: 0,
        entryPerPage: 10,
        sortingColumn: listPSODirBatchUpdateSortColumn.sortField,
        sortingOrder: listPSODirBatchUpdateSortColumn.sortDirection,
        searchTerm: ""
      });
    }
  }, []);
  
  const generateBatchDetailReport = async (batchId, token) => {
    let status = STATUSES.SUCCESS;
    
    const body = {
      batchId: batchId,
    };
    
    const res = await httpDownload
      .post(BD_GENERATE_URL, body, {
        responseType: "blob",
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        return Promise.resolve({ status: status, data: res });
      })
      .catch(function (error) {
        status = STATUSES.ERROR;
        return Promise.reject({ status: status, data: error });
      });
    
    return res;
  };
  
  
  const handleFileDownload = async (batch) => {
    
    const res = await generateBatchDetailReport(batch.batchId, "Bearer " + loginState.token,).catch((error) => {
      const payload = error?.data ?? error;
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
    
    if (res?.status?.code === 1) {
      const fileName =
        res.data.headers["content-disposition"]
          ?.split("filename=")[1]
          .split(";")[0]
          .replace(/^"(.*)"$/, "$1") || "web-analytics-report.csv";
      
      const url = window.URL.createObjectURL(res.data.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: res?.data?.status?.text
      });
    }
  }
  
  return (
    <>
      {filter != null ?
        <DatatableBase
          tableClassName="wsAccountTable"
          reload={reloadListPSODirBatchUpdate}
          setReload={setReloadListPSODirBatchUpdate}
          getData={getData}
          getListCols={getListCols}
          filter={filter}
          setFilter={setFilter}
          searchFieldText = {"Search by Batch ID or Batch Status"}
          datatableHeader={null}
          datatableDescription={null}
          sortingColumn={listPSODirBatchUpdateSortColumn.sortField}
          sortingOrder={listPSODirBatchUpdateSortColumn.sortDirection}
        >
        </DatatableBase> : null}
    </>
  )
  
}

export default ListPSODirectoryBatchUpdate;